module.exports = __webpack_public_path__ + "img/charging-plate.97c5def1.png";